import { observer } from 'mobx-react';
import React, { type JSX } from 'react';

interface Props<T> {
  dividerFn: () => JSX.Element;
  mapFn: (item: T) => JSX.Element;
  items: ReadonlyArray<T>;
}

function jsxMapWithSeparator<T>(
  divider: Props<T>['dividerFn'],
  mapFn: Props<T>['mapFn'],
  items: Props<T>['items'],
) {
  const indexedDivider = (idx: number) => (
    <React.Fragment key={`sep_${idx}`}>{divider()}</React.Fragment>
  );

  return items.reduce<JSX.Element[]>((accum, item, idx): JSX.Element[] => {
    return idx === 0 ? [...accum, mapFn(item)] : [...accum, indexedDivider(idx), mapFn(item)];
  }, []);
}

function MapWithSeparator<T>({ dividerFn, mapFn, items }: Props<T>): React.ReactElement {
  return <>{jsxMapWithSeparator(dividerFn, mapFn, items)}</>;
}

export default observer(MapWithSeparator);
